import { render, staticRenderFns } from "./EditField.vue?vue&type=template&id=044a9bfa&scoped=true&lang=pug"
import script from "./EditField.vue?vue&type=script&lang=js"
export * from "./EditField.vue?vue&type=script&lang=js"
import style0 from "./EditField.vue?vue&type=style&index=0&id=044a9bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a9bfa",
  null
  
)

export default component.exports